module.exports = __webpack_public_path__ + "media/application/images/projects/secondary_nav/oil-and-gas-f4a951aa22de37bdf89366d9aee40d40.jpg";